const getNamespacedFieldName = (fieldName, namespace) =>
  namespace ? `${namespace}.${fieldName}` : fieldName;

export default getNamespacedFieldName;
